import { render, staticRenderFns } from "./AppTranslationForm.vue?vue&type=template&id=03f652d5&scoped=true&"
import script from "./AppTranslationForm.vue?vue&type=script&lang=js&"
export * from "./AppTranslationForm.vue?vue&type=script&lang=js&"
import style0 from "./AppTranslationForm.vue?vue&type=style&index=0&id=03f652d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f652d5",
  null
  
)

export default component.exports